import { useEffect } from 'react';
import { useAccountListStore } from '../../contexts/AccountListContext';
import { HoverTooltip, Loading } from '../atoms';
import { DisplayTable, DisplayTableHead, DisplayTableRow } from '../molecules';
import type { TMerchant } from '../types';
import { ViewAsEPButton } from '../molecules/ViewAsEPButton';

const AccountsList = () => {
  const store = useAccountListStore();
  useEffect(() => {
    store.setMerchants();
  }, []);
  const merchants = store.merchants;
  const isLoading = store.isLoading;

  return (
    <>
      <DisplayTable
        colWidths={['180px', '154px', '154px', '1fr', '154px']}
        colWidthsMd={['11rem', '9rem', '9rem', '1fr', '9rem']}
      >
        <DisplayTableHead
          cols={[
            'Account ID',
            'Status',
            'Account Name',
            'Trading Name',
            'View as EP'
          ]}
        />
        {!isLoading && merchants.length === 0 && (
          <DisplayTable colWidths={['auto']} colWidthsMd={['auto']}>
            <DisplayTableRow
              type="div"
              cells={[
                {
                  contentType: 'error',
                  content: 'No Courses found'
                }
              ]}
            />
          </DisplayTable>
        )}
        {isLoading && <Loading />}
        {!isLoading &&
          merchants
            .sort((a: TMerchant, b: TMerchant) => a.id.localeCompare(b.id))
            .map((merchant: TMerchant) => (
              <DisplayTableRow
                key={merchant.id}
                type="link"
                action={`/account/${merchant.id}`}
                button={
                  <HoverTooltip text={`View as EP: ${merchant.id}`} show>
                    <ViewAsEPButton merchantId={merchant.id} />
                  </HoverTooltip>
                }
                cells={[
                  {
                    contentType: 'text',
                    content: `${merchant.id}`
                  },
                  {
                    contentType: 'text',
                    content: 'Customer'
                  },
                  {
                    contentType: 'text',
                    content: `${merchant.accountName}`
                  },
                  {
                    contentType: 'text',
                    content: `${merchant.tradingName}`
                  }
                ]}
              />
            ))}
      </DisplayTable>
    </>
  );
};

export { AccountsList };
